/** 正のSQLite整数IDだけを受け付ける。指数表記、小数、範囲外の値はnull。副作用なし。 */
export function parseArticleId(value: unknown): bigint | null {
	if (typeof value !== "string" || !/^\d{1,19}$/.test(value)) return null;
	const id = BigInt(value);
	return id > BigInt(0) && id <= BigInt("9223372036854775807") ? id : null;
}
